import { Routes, Route, Navigate } from 'react-router-dom';
import { LoginPage } from '@/pages/LoginPage';
import { TwoFactorPage } from '@/pages/TwoFactorPage';
import { HomePage } from '@/pages/HomePage';
import { ChoisirSocietePage } from '@/pages/ChoisirSocietePage';
import { ReportingPage } from '@/pages/reporting/ReportingPage';
import { DashboardPage } from '@/pages/finance/DashboardPage';
import { JournalPage } from '@/pages/finance/JournalPage';
import { LettragePage } from '@/pages/finance/LettragePage';
import { EtatsComptablesPage } from '@/pages/finance/EtatsComptablesPage';
import { ReleveComptePage } from '@/pages/finance/ReleveComptePage';
import { FacturesFournisseursPage } from '@/pages/finance/FacturesFournisseursPage';
import { InvoicesPage } from '@/pages/finance/InvoicesPage';
import { InvoicePrintView } from '@/pages/finance/InvoicePrintView';
import { TarifsContratsPage } from '@/pages/finance/TarifsContratsPage';
import { PersonnelPage } from '@/pages/hr/PersonnelPage';
import { PointagePage } from '@/pages/hr/PointagePage';
import { PaieParametresPage } from '@/pages/hr/PaieParametresPage';
import { ArrieresPage } from '@/pages/hr/ArrieresPage';
import { ContactsPage } from '@/pages/crm/ContactsPage';
import { PipelinePage } from '@/pages/crm/PipelinePage';
import { CataloguePage } from '@/pages/operations/beton/CataloguePage';
import { ProduitDetailPage } from '@/pages/operations/beton/ProduitDetailPage';
import { MatieresPremieresPage } from '@/pages/operations/beton/MatieresPremieresPage';
import { ProductionPage } from '@/pages/operations/beton/ProductionPage';
import { PiecesLotPage } from '@/pages/operations/beton/PiecesLotPage';
import { ProductionJournalierePage } from '@/pages/operations/beton/ProductionJournalierePage';
import { ChantiersPage } from '@/pages/operations/beton/ChantiersPage';
import { CommandesPage } from '@/pages/operations/beton/CommandesPage';
import { GacheesPage } from '@/pages/operations/beton/GacheesPage';
import { ControleQualitePage } from '@/pages/operations/beton/ControleQualitePage';
import { ParcPage } from '@/pages/operations/beton/ParcPage';
import { EcartsInventairePage } from '@/pages/operations/EcartsInventairePage';
import { MainOeuvrePage } from '@/pages/operations/MainOeuvrePage';
import { ExpeditionsPage } from '@/pages/operations/beton/ExpeditionsPage';
import { StocksHealthPage } from '@/pages/operations/beton/StocksHealthPage';
import { ReclamationsPage } from '@/pages/operations/beton/ReclamationsPage';
import { BalanceAgeePage } from '@/pages/finance/BalanceAgeePage';
import { PatrimoinePage } from '@/pages/patrimoine/PatrimoinePage';
import { DemandesTerrainPage } from '@/pages/achats/DemandesTerrainPage';
import { FournisseursPage } from '@/pages/operations/beton/FournisseursPage';
import { AchatsPage } from '@/pages/operations/beton/AchatsPage';
import { MaintenanceMoulesPage } from '@/pages/operations/beton/MaintenanceMoulesPage';
import { DashboardDGPage } from '@/pages/operations/beton/DashboardDGPage';
import { FlottePage } from '@/pages/operations/FlottePage';
import { EquipesPage } from '@/pages/operations/transport/EquipesPage';
import { RotationsPage } from '@/pages/operations/transport/RotationsPage';
import { RapportJournalierPage } from '@/pages/operations/transport/RapportJournalierPage';
import { CarburantPage } from '@/pages/operations/transport/CarburantPage';
import { MaintenancePage } from '@/pages/operations/transport/MaintenancePage';
import { HotspotsPage } from '@/pages/operations/telecom/HotspotsPage';
import { AbonnesPage } from '@/pages/operations/telecom/AbonnesPage';
import { RevenusPage } from '@/pages/operations/telecom/RevenusPage';
import { ProgrammesPage } from '@/pages/operations/immobilier/ProgrammesPage';
import { LotsImmoPage } from '@/pages/operations/immobilier/LotsImmoPage';
import { ReservationsVefaPage } from '@/pages/operations/immobilier/ReservationsVefaPage';
import { MachinesPage } from '@/pages/operations/textprint/MachinesPage';
import { CommandesImpressionPage } from '@/pages/operations/textprint/CommandesImpressionPage';
import { OrdresImpressionPage } from '@/pages/operations/textprint/OrdresImpressionPage';
import { ConsommablesPage } from '@/pages/operations/textprint/ConsommablesPage';
import { DevisImpressionPage } from '@/pages/operations/textprint/DevisImpressionPage';
import { SousTraitantsPage } from '@/pages/operations/textprint/SousTraitantsPage';
import { BoutiqueCataloguePage } from '@/pages/operations/boutique/BoutiqueCataloguePage';
import { BoutiqueClientsPage } from '@/pages/operations/boutique/BoutiqueClientsPage';
import { BoutiqueStocksPage } from '@/pages/operations/boutique/BoutiqueStocksPage';
import { CommandesBoutiquePage } from '@/pages/operations/boutique/CommandesBoutiquePage';
import { VitrineHomePage } from '@/pages/vitrine/textprint/VitrineHomePage';
import { VitrineProduitPage } from '@/pages/vitrine/textprint/VitrineProduitPage';
import { OperationsPage } from '@/pages/operations/OperationsPage';
import { IntervenantsAccesPage } from '@/pages/terrain/IntervenantsAccesPage';
import { ValidationsPage as TerrainValidationsPage } from '@/pages/terrain/ValidationsPage';
import { ParametresPage as TerrainParametresPage } from '@/pages/terrain/ParametresPage';
import { JournalPage as TerrainJournalPage } from '@/pages/terrain/JournalPage';
import { HoldingPage } from '@/pages/holding/HoldingPage';
import { UsersAdminPage } from '@/pages/holding/UsersAdminPage';
import { FilialesAccessPage } from '@/pages/holding/FilialesAccessPage';
import { FilialeLegalPage } from '@/pages/holding/FilialeLegalPage';
import { QrLotPage } from '@/pages/QrLotPage';
import { AppLayout } from '@/components/layout/AppLayout';
import { ProtectedRoute } from '@/components/layout/ProtectedRoute';
// SIMG-COMMERCIAL-LEADBETON-2026-001 — Portail commercial + validation DAF unifiée
import { CommercialLayout } from '@/layouts/CommercialLayout';
import { AccueilPage as CommercialAccueilPage } from '@/pages/commercial/AccueilPage';
import { NouvelleProformaPage } from '@/pages/commercial/NouvelleProformaPage';
import { MesProformasPage } from '@/pages/commercial/MesProformasPage';
import { MesCommandesPage as CommercialMesCommandesPage } from '@/pages/commercial/MesCommandesPage';
import { MesProspectsPage } from '@/pages/commercial/MesProspectsPage';
import { ClientsPage } from '@/pages/commercial/ClientsPage';
import { ValidationsUnifieePage } from '@/pages/validation/ValidationsUnifieePage';
import { MonComptePage } from '@/pages/MonComptePage';
// SIMG-ACHATS-LEADBETON-2026-002 — Portail acheteur
import { AchatsLayout } from '@/layouts/AchatsLayout';
import { AccueilPage as AchatsAccueilPage } from '@/pages/achats/AccueilPage';
import { NouveauBcaPage } from '@/pages/achats/NouveauBcaPage';
import { MesBcasPage } from '@/pages/achats/MesBcasPage';
import { FournisseursPage as AchatsFournisseursPage } from '@/pages/achats/FournisseursPage';

const App = () => (
  <Routes>
    {/* Routes publiques */}
    <Route path="/login"     element={<LoginPage />} />
    <Route path="/login/2fa" element={<TwoFactorPage />} />
    {/* Traçabilité QR — accès sans auth pour scan chantier (Sprint LB-C) */}
    <Route path="/qr/lot/:id" element={<QrLotPage />} />
    {/* Vitrine publique TEXTIPRINT (Sprint 3) — boutiquetextiprint.ci white-label
        En prod, nginx routera le sous-domaine vers /vitrine. Pas d'AppLayout. */}
    <Route path="/vitrine"                element={<VitrineHomePage />} />
    <Route path="/vitrine/produit/:sku"   element={<VitrineProduitPage />} />

    {/* Lot 1, étape 1.7 — choix de la société après connexion (personnes rattachées à plusieurs sociétés) */}
    <Route path="/choisir-societe" element={<ProtectedRoute><ChoisirSocietePage /></ProtectedRoute>} />

    {/* Route imprimable (protégée mais SANS AppLayout — pas de sidebar/header) */}
    <Route
      path="/finance/invoices/:id/print"
      element={<ProtectedRoute><InvoicePrintView /></ProtectedRoute>}
    />

    {/* SIMG-COMMERCIAL-LEADBETON-2026-001 — Portail commercial (layout dédié mobile-first) */}
    <Route
      path="/commercial"
      element={
        <ProtectedRoute roles={['commercial', 'daf', 'dg_filiale', 'admin_holding']}>
          <CommercialLayout />
        </ProtectedRoute>
      }
    >
      <Route index                element={<CommercialAccueilPage />} />
      <Route path="clients"       element={<ClientsPage />} />
      <Route path="nouvelle"      element={<NouvelleProformaPage />} />
      <Route path="proformas"     element={<MesProformasPage />} />
      <Route path="commandes"     element={<CommercialMesCommandesPage />} />
      <Route path="prospects"     element={<MesProspectsPage />} />
    </Route>

    {/* SIMG-ACHATS-LEADBETON-2026-002 — Portail acheteur (layout dédié mobile-first) */}
    <Route
      path="/achats"
      element={
        <ProtectedRoute roles={['acheteur', 'daf', 'dg_filiale', 'admin_holding']}>
          <AchatsLayout />
        </ProtectedRoute>
      }
    >
      <Route index                element={<AchatsAccueilPage />} />
      <Route path="nouveau"       element={<NouveauBcaPage />} />
      <Route path="bca"           element={<MesBcasPage />} />
      <Route path="fournisseurs"  element={<AchatsFournisseursPage />} />
    </Route>

    {/* Routes protégées (layout commun) */}
    <Route element={<ProtectedRoute><AppLayout /></ProtectedRoute>}>
      <Route index                  element={<HomePage />} />

      {/* Mon compte — ouvert à tous les rôles : chacun n'agit que sur le sien. */}
      <Route path="/mon-compte"     element={<MonComptePage />} />

      {/* SIMG-COMMERCIAL-LEADBETON-2026-001 — Écran DAF validations unifiées */}
      <Route
        path="/validation"
        element={
          <ProtectedRoute roles={['admin_holding', 'daf', 'dg_filiale']}>
            <ValidationsUnifieePage />
          </ProtectedRoute>
        }
      />

      {/* Finance — Dashboard branché sur API live (Jour 3) */}
      <Route path="/finance"            element={<DashboardPage />} />
      <Route path="/finance/journal"    element={<JournalPage />} />
      <Route path="/finance/fournisseurs" element={<ProtectedRoute roles={['daf', 'dg_filiale', 'admin_holding', 'auditeur', 'acheteur']}><FacturesFournisseursPage /></ProtectedRoute>} />
      <Route path="/finance/etats"      element={<ProtectedRoute roles={['daf', 'dg_filiale', 'admin_holding', 'auditeur']}><EtatsComptablesPage /></ProtectedRoute>} />
      {/* 30/10/2026 — relevé de compte d'un client ou d'un fournisseur (commercial : clients ; acheteur : fournisseurs) */}
      <Route path="/finance/releves/:contactId" element={<ProtectedRoute roles={['daf', 'dg_filiale', 'admin_holding', 'auditeur', 'commercial', 'acheteur']}><ReleveComptePage /></ProtectedRoute>} />
      <Route path="/finance/lettrage"   element={<ProtectedRoute roles={['daf', 'dg_filiale', 'admin_holding', 'auditeur']}><LettragePage /></ProtectedRoute>} />
      <Route path="/finance/invoices"   element={<InvoicesPage />} />
      <Route path="/finance/tarifs-contrats" element={<TarifsContratsPage />} />

      {/* SIMG-PATRIMOINE-2026-001 — registre des immobilisations */}
      <Route path="/patrimoine"         element={<PatrimoinePage />} />

      {/* SIMG-DEMANDE-TERRAIN-2026-001 — demandes des chantiers, cote acheteur */}
      <Route path="/achats/demandes"    element={<DemandesTerrainPage />} />

      {/* RH + CRM (Jour 6) */}
      <Route path="/hr"            element={<PersonnelPage />} />
      <Route path="/hr/pointage"   element={<PointagePage />} />
      <Route path="/hr/paie"       element={<PaieParametresPage />} />
      <Route path="/hr/arrieres"   element={<ArrieresPage />} />
      <Route path="/crm"           element={<ContactsPage />} />
      <Route path="/crm/pipeline"  element={<PipelinePage />} />
      <Route path="/reporting"     element={<ReportingPage />} />
      {/* sous-routes /reporting/* non implementees : ecran de repli */}
      <Route path="/reporting/*"   element={<HomePage />} />
      {/* Opérations · Béton — Catalogue dynamique (Sprint LB-A) */}
      <Route path="/operations/catalogue"       element={<CataloguePage />} />
      <Route path="/operations/catalogue/:id"   element={<ProduitDetailPage />} />
      <Route path="/operations/matieres"        element={<MatieresPremieresPage />} />
      <Route path="/operations/production"      element={<ProductionPage />} />
      <Route path="/operations/production/lots/:lotId/pieces" element={<PiecesLotPage />} />
      <Route path="/operations/production-journaliere" element={<ProductionJournalierePage />} />
      {/* Sprint 2 — Modules 4+5+6 préfa */}
      <Route path="/operations/gachees"         element={<GacheesPage />} />
      <Route path="/operations/qc"              element={<ControleQualitePage />} />
      <Route path="/operations/parc"            element={<ParcPage />} />
      {/* Sprint 3 — Modules 7+8 préfa */}
      <Route path="/operations/stocks"          element={<StocksHealthPage />} />
      {/* 29/09/2026 — les constats d'inventaire physique, et ce qui reste a trancher */}
      <Route path="/operations/inventaire"      element={<EcartsInventairePage />} />
      {/* 29/09/2026 — journaliers : registre, journees a regler, historique */}
      <Route path="/operations/main-oeuvre"     element={<MainOeuvrePage />} />
      {/* 29/09/2026 — les couts ont rejoint l ecran Main-d oeuvre. On garde la
          route pour ne pas casser un lien deja partage : elle y renvoie. */}
      <Route path="/operations/couts-main-oeuvre" element={<Navigate to="/operations/main-oeuvre" replace />} />
      <Route path="/operations/expeditions"     element={<ExpeditionsPage />} />
      {/* Sprint 4 — Modules 9+10 */}
      <Route path="/operations/reclamations"    element={<ReclamationsPage />} />
      <Route path="/finance/balance-agee"       element={<BalanceAgeePage />} />
      {/* Sprint 5 — Modules 11+12 */}
      <Route path="/operations/fournisseurs"    element={<FournisseursPage />} />
      <Route path="/operations/achats"          element={<AchatsPage />} />
      <Route path="/operations/maintenance-moules" element={<MaintenanceMoulesPage />} />
      {/* Sprint 6 — Module 15 Dashboard DG */}
      <Route path="/operations/dashboard-dg"    element={<DashboardDGPage />} />
      <Route path="/operations/chantiers"       element={<ChantiersPage />} />
      <Route path="/operations/commandes"       element={<CommandesPage />} />
      <Route path="/operations/flotte"          element={<FlottePage />} />
      <Route path="/operations/equipes"         element={<EquipesPage />} />
      <Route path="/operations/rotations"       element={<RotationsPage />} />
      <Route path="/operations/rapport"         element={<RapportJournalierPage />} />
      <Route path="/operations/carburant"       element={<CarburantPage />} />
      <Route path="/operations/maintenance"     element={<MaintenancePage />} />
      <Route path="/operations/hotspots"        element={<HotspotsPage />} />
      <Route path="/operations/abonnes"         element={<AbonnesPage />} />
      <Route path="/operations/revenus"         element={<RevenusPage />} />
      <Route path="/operations/programmes"      element={<ProgrammesPage />} />
      <Route path="/operations/lots"            element={<LotsImmoPage />} />
      <Route path="/operations/vefa"            element={<ReservationsVefaPage />} />
      {/* Opérations · Textprint (Phase 2) */}
      <Route path="/operations/machines"             element={<MachinesPage />} />
      <Route path="/operations/commandes-impression" element={<CommandesImpressionPage />} />
      <Route path="/operations/of-impression"        element={<OrdresImpressionPage />} />
      <Route path="/operations/consommables"         element={<ConsommablesPage />} />
      <Route path="/operations/devis-impression"     element={<DevisImpressionPage />} />
      <Route path="/operations/sous-traitants"       element={<SousTraitantsPage />} />
      <Route path="/operations/boutique/catalogue"   element={<BoutiqueCataloguePage />} />
      <Route path="/operations/boutique/commandes"   element={<CommandesBoutiquePage />} />
      <Route path="/operations/boutique/clients"     element={<BoutiqueClientsPage />} />
      <Route path="/operations/boutique/stocks"      element={<BoutiqueStocksPage />} />
      <Route path="/operations"                 element={<OperationsPage />} />

      {/* SIMG-TERRAIN-2026-001 — Back-office Portail Terrain (LeadBeton CI) */}
      <Route
        path="/terrain/intervenants"
        element={<ProtectedRoute roles={['admin_holding', 'daf', 'dg_filiale', 'manager']}><IntervenantsAccesPage /></ProtectedRoute>}
      />
      <Route
        path="/terrain/validations"
        element={<ProtectedRoute roles={['admin_holding', 'daf', 'dg_filiale', 'manager']}><TerrainValidationsPage /></ProtectedRoute>}
      />
      <Route
        path="/terrain/parametres"
        element={<ProtectedRoute roles={['admin_holding', 'daf', 'dg_filiale', 'manager']}><TerrainParametresPage /></ProtectedRoute>}
      />
      <Route
        path="/terrain/journal"
        element={<ProtectedRoute roles={['admin_holding', 'daf', 'dg_filiale', 'manager']}><TerrainJournalPage /></ProtectedRoute>}
      />

      {/* Holding consolidé (Jour 6 brief) — admin_holding + auditeur uniquement */}
      <Route
        path="/holding"
        element={<ProtectedRoute roles={['admin_holding', 'auditeur']}><HoldingPage /></ProtectedRoute>}
      />
      {/* Fiches sociétés (lot 1, étape 1.7 : l'ouverture d'une société passe par le sélecteur) */}
      <Route
        path="/holding/filiales"
        element={<ProtectedRoute roles={['admin_holding', 'auditeur']}><FilialesAccessPage /></ProtectedRoute>}
      />
      {/* CTO-ACCESS-001 — Administration cross-tenant users (admin_holding strict) */}
      <Route
        path="/holding/users"
        element={<ProtectedRoute roles={['admin_holding']}><UsersAdminPage /></ProtectedRoute>}
      />
      {/* SIMGROUP-2026-003 Sprint 1 — Édition mentions légales OHADA */}
      <Route
        path="/holding/filiales/:filialeKey/legal"
        element={<ProtectedRoute roles={['admin_holding']}><FilialeLegalPage /></ProtectedRoute>}
      />
      {/* Catch-all sub-routes /holding/* (filiales, alertes, rapports, settings à venir) */}
      <Route path="/holding/*"    element={<HomePage />} />
    </Route>

    {/* Catch-all */}
    <Route path="*" element={<Navigate to="/" replace />} />
  </Routes>
);

export default App;
